import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  assetConnectivityTableHeader: {
    height: 48,
    alignContent: 'center',
    padding: '0 1rem',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.235,
    borderRadius: '4px 4px 0 0'
  },
  assetConnectivityTableWrapper: {
    height: 'calc(10 * 50px)',
    minHeight: 100,
    borderRadius: '4px !important',
    '& .ag-wrapper': {
      borderRadius: '4px !important'
    },
    '& .ag-root-wrapper': {
      borderRadius: '4px !important'
    }
  }
}));

export default useStyles;
